



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { RegionState, Region, DataRegion } from '@/store/region/types';
import {
  AdminSiteState,
  AdminSite,
  DataAdminSite,
} from '@/store/adminsite/types';
import { IMessage } from '@/store/alert/types';
import Alert from '@/components/Alert.vue';
import Table from '@/components/Table.vue';
import Cards from '@/components/Cards.vue';

@Component({
  components: {
    Alert,
    Table,
    Cards,
  },
})
export default class ManagementRegion extends Vue {
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @Mutation('REGION_PUT', { namespace: 'region' })
  private regionPut: any;
  @Mutation('REGION_ADMINSITE_CREATE', { namespace: 'region' })
  private regionCreate: any;
  @Mutation('REGION_ADMINSITE_DELETE', { namespace: 'region' })
  private regionDelete: any;
  @Action('add', { namespace: 'region' }) private add: (
    region: Region,
  ) => Promise<undefined>;
  @Action('put', { namespace: 'region' }) private put: (
    region: Region,
  ) => Promise<undefined>;
  @Action('delete', { namespace: 'region' }) private delete: (
    _id: string,
  ) => Promise<undefined>;
  @Action('get', { namespace: 'region' }) private get: () => void;
  @Action('get', { namespace: 'adminsite' }) private getAdminSite: () => void;

  @State('adminsite') private adminState?: AdminSiteState;
  @State('region') private regionState?: RegionState;
  @Prop(String) private search?: string;

  canOtherPut: Boolean = true;

  get filter() {
    let dataRegions: DataRegion[];
    let dataAdminSites: DataAdminSite[];
    dataRegions = this.regionState!.dataRegion
      ? this.regionState!.dataRegion
      : [];
    dataAdminSites = this.adminState!.dataAdminSite
      ? this.adminState!.dataAdminSite
      : [];

    let filteredArray = dataAdminSites!.filter((adminsite) => {
      let found = false;
      if (dataRegions)
        dataRegions!.forEach((dataRegion) => {
          if (dataRegion.adminsites)
            dataRegion.adminsites!.forEach((d) => {
              found = found || adminsite._id === d._id;
            });
        });
      return !found;
    });
    return filteredArray.sort(function(a: any, b: any): any {
      if (a.name && b.name) return a.name.localeCompare(b.name);
    });
  }

  private mounted() {
    this.get();
    this.getAdminSite();
  }

  public putEvent() {
    this.canOtherPut = false;
  }

  public onCancel() {
    this.canOtherPut = true;
    this.get();
    this.getAdminSite();
  }

  public activeCreate() {
    if (this.canOtherPut === true) {
      this.canOtherPut = false;
      this.regionCreate();
    }
  }

  public onCreate(region: DataRegion) {
    let array: AdminSite[] = [];
    let name: string = '';
    for (let i = 0; i < region.adminsites!.length; i++) {
      array.push(region.adminsites![i]);
    }
    name = region.name! !== '' ? region.name! : '';
    let singleRegion = {
      name: name,
      adminsites: array,
    };
    if (singleRegion && singleRegion.name !== undefined) {
      this.add(singleRegion)
        .then(() => {
          this.canOtherPut = true;
          this.get();
          this.getAdminSite();
        })
        .catch(() => {});
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public onPut(arg: Region) {
    let array: AdminSite[] = [];
    let name: string = '';
    for (let i = 0; i < arg.adminsites!.length; i++) {
      array.push(arg.adminsites![i]);
    }
    name = arg.name! !== '' ? arg.name! : '';
    let singleRegion = {
      _id: arg._id,
      name: name,
      adminsites: array,
    };
    if (singleRegion && singleRegion.name !== '') {
      this.put(singleRegion)
        .then(() => {
          this.canOtherPut = true;
          this.get();
          this.getAdminSite();
        })
        .catch(() => {});
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public onDelete(arg: DataRegion) {
    let Conf = confirm('Voulez-vous supprimer votre region ?');
    if (Conf === true) {
      if (arg._id) {
        this.delete(arg._id)
          .then(() => {
            this.get();
            this.getAdminSite();
          })
          .catch(() => {});
      }
    }
  }

  public addBox(arg: DataRegion) {
    this.regionPut(arg);
  }

  public deleteBox(arg: DataAdminSite) {
    this.regionDelete(arg);
  }
}
